import type {
	CalendarRef,
	CalendarSelectOption,
	SubGoal,
	SubGoals,
} from '../../../../../../../../../common/types';

export const appendNewSubGoal = (list: SubGoals = [], newGoal: SubGoal) => {
	const result = Array.from<SubGoal>(list);
	return [...result, newGoal] as const;
};

export const formatOptions = (calendarRefs: CalendarRef[]) =>
	calendarRefs.map<CalendarSelectOption>(({ name, id, ...rest }) => ({
		label: name,
		value: id,
		isDefaultOption: rest.default,
	}));
